export const COOKIE = {
  user: 'user',
  authToken: 'authToken',
  refreshToken: 'refreshToken',
}
